/* ============================================================
   1. COLECȚIE — Citește mai mult / mai puțin (descriere lungă)
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
  const desc = document.querySelector(
    '.collection-hero__description, .collection-description, .rte.description'
  );

  if (desc && desc.scrollHeight > 150) {
    desc.classList.add('desc-is-long');

    const btn = document.createElement('button');
    btn.className = 'auto-read-more-btn';
    btn.style.display = 'flex';
    btn.innerHTML =
      '<span>CITEȘTE MAI MULT</span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

    desc.parentNode.insertBefore(btn, desc.nextSibling);

    btn.addEventListener('click', function () {
      const isExpanded = desc.classList.toggle('is-expanded');
      btn.querySelector('span').innerText = isExpanded
        ? 'CITEȘTE MAI PUȚIN'
        : 'CITEȘTE MAI MULT';

      if (!isExpanded) {
        desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
});

